import { orchestrator } from 'satcheljs';
import { connectedAccountDisconnected } from 'owa-accounts-service';
import setAccountsEditorState from '../mutators/setAccountsEditorState';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import { logUsage } from 'owa-analytics';
import { getOwaSessionAddedAccountCreatedTimestamp } from '../selectors/getCurrentSessionAccounts';
import { differenceInMilliseconds, now, OwaDate } from 'owa-datetime';
import { TimeConstants } from 'owa-datetime-utils';
import { getExtendedDurationBucket } from '../utils/telemetryBucketUtils';
import { isFeatureEnabled } from 'owa-feature-flags';
import getIsAccountRemovalErrorDialogReferral from '../selectors/getIsAccountRemovalErrorDialogReferral';
import {
    showDisconnectFeedbackDialog,
    lazyGetHasShownDisconnectFeedbackDialog,
} from 'owa-accounts-feedback';

orchestrator(connectedAccountDisconnected, async ({ userIdentity, isReconnectFlow }) => {
    if (!isReconnectFlow) {
        setAccountsEditorState(AccountsEditorState.Removed);
    }

    const duration = getDuration(getOwaSessionAddedAccountCreatedTimestamp(userIdentity));

    logUsage('connectedAccountDisconnected', {
        sameSessionConnectDisconnecteAccountDuration: duration,
        sameSessionConnectDisconnecteAccountDuration_1: getExtendedDurationBucket(duration),
    });

    if (isFeatureEnabled('cal-multiAccounts-disconnect-feedback')) {
        let getHasShownDisconnectFeedbackDialog = await lazyGetHasShownDisconnectFeedbackDialog.import();

        if (!getHasShownDisconnectFeedbackDialog()) {
            showDisconnectFeedbackDialog(duration > 0, getIsAccountRemovalErrorDialogReferral());
        }
    }
});

function getDuration(start: OwaDate) {
    return start ? differenceInMilliseconds(now(), start) / TimeConstants.MillisecondsIn1Sec : null;
}
